export default __webpack_public_path__ + "static/media/list.b63d981c.svg";